export const ORGANIZATION_ID_NCE = 1;
export const ORGANIZATION_ID_COMMITTEE = 2;